<template>
  <v-container id="contact" class="fill-height" tag="section">
    <v-row class="text-center" justify="center">
      <v-col cols="auto">
        <div class="page-title">
          Hello
          <span class="primary--text">.</span>
        </div>
        <div class="display-2">
          If you want to find out more about Producer&trade; or Odro
          <sup>&reg;</sup>
        </div>
        <div class="display-2">We want to hear from you.</div>
        <v-divider class="mt-8" />
        <v-row class="mt-4">
          <v-col cols="12" md="6">
            <v-card color="rgba(255,255,255,0.3)">
              <v-card-title class="justify-center display-3 mb-2 font-weight-bold">Support</v-card-title>
              <v-card-text>
                <div class="headline py-4">Tel. +44 (0) 141 465 9470</div>
                <div class="headline mt-3">
                  Email.
                  <a href="mailto:support@odro.co.uk" class="public-page-link">support@odro.co.uk</a>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card color="rgba(255,255,255,0.2)">
              <v-card-title class="justify-center display-3 mb-2 font-weight-bold">Sales</v-card-title>
              <v-card-text>
                <div class="headline py-4">
                  Request a
                  <v-btn
                    href="https://www.odro.co.uk/demorequest/"
                    target="_blank"
                    color="primary"
                    depressed
                    class="ml-2"
                  >
                    demo
                  </v-btn>
                </div>
                <div class="headline">
                  Email.
                  <a href="mailto:hello@odro.co.uk" class="public-page-link">hello@odro.co.uk</a>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-divider class="mt-2 mb-6" />
            <v-btn outlined icon color="white" href="https://www.linkedin.com/company/odro">
              <fa-icon :icon="['fab', 'linkedin-in']" size="lg" />
            </v-btn>
            <v-btn outlined icon color="white" href="https://www.instagram.com/teamodro/">
              <fa-icon :icon="['fab', 'instagram']" size="lg" />
            </v-btn>
            <v-btn outlined icon color="white" href="https://www.facebook.com/OdroSoftware/">
              <fa-icon :icon="['fab', 'facebook-f']" size="lg" />
            </v-btn>
            <v-btn outlined icon color="white" href="https://www.youtube.com/channel/UC_8FxY1ThLbhWN0kp6bPWCg">
              <fa-icon :icon="['fab', 'youtube']" size="lg" />
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Contact',
  layout: 'public',
  auth: false,
};
</script>

<style lang="sass">
.page-title
  font-size: 10rem
</style>
